var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCardBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 43,
    viewBox: "0 0 119 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.821 19.3661V1.95536L118 6.01786V24.0089L101.808 42L39.6518 42L35.9955 37.9375L1.00001 37.9375V35.0357L99.7188 35.0357L113.821 19.3661Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 1.16071
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCardBorder);
export default __webpack_public_path__ + "static/media/right-card-border.9af7e7d4d316c397847582d33ac47251.svg";
export { ForwardRef as ReactComponent };